// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';

// Utils
import { asObject } from '../../../../../../../common/utils/immutableHelper';
import {
    getElementChangeElementTypeDisplayName,
    getUpdateSummaryList,
} from '../../../../../../../common/notifications/elementChangesUtils';
import { getNotificationElementChanges } from '../../../../../../../common/notifications/notificationModelUtils';
import { isBoard } from '../../../../../../../common/elements/utils/elementTypeUtils';

// Components
import Icon from '../../../../../../components/icons/Icon';
import NewBoardTitleSummary from './NewBoardTitleSummary';

// Styles
import './NotificationElementChangeSummary.scss';

const NotificationElementChangeSummary = (props) => {
    const { notification } = props;

    const elementChanges = asObject(getNotificationElementChanges(notification));

    if (isEmpty(elementChanges)) return null;

    const updateSummaryList = getUpdateSummaryList(elementChanges);

    return (
        <div className="NotificationElementChangeSummary">
            {updateSummaryList.map(({ groupName, changeType, elementType, count }) => {
                const displayName = getElementChangeElementTypeDisplayName({ elementType, count });
                const iconName = `notification-${groupName}`;

                return (
                    <div className="change-summary" key={`${changeType}-${elementType}`}>
                        <div className="type-icon">
                            <Icon name={iconName} />
                        </div>
                        <div className="change-details">
                            <div>{`${changeType} ${count} ${displayName}`}</div>
                            {isBoard(elementType) && <NewBoardTitleSummary notification={notification} />}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

NotificationElementChangeSummary.propTypes = {
    notification: PropTypes.object,
};

export default NotificationElementChangeSummary;
